import React from 'react'

export default ({ title, subtitle, heroImage, childComponent }) => (
  <>
    <div className="clipped-container clipped-positioning">
      <section className="section is-large bg-gradient-reverse is-clipped clipped-large" />
    </div>

    <section className="section is-large">
      <div className="container content">
        <div className="columns is-centered">
          <div className="column is-8 is-narrow has-text-centered-tablet">
            <h1>{title}</h1>
            <div className="text-box text-large">{subtitle}</div>
          </div>
        </div>

        {childComponent && (
          <div className="columns is-centered">
            <div className="column is-10-widescreen is-12">
              {childComponent}
            </div>
          </div>
        )}
        {heroImage && (
          <div className="centered-image">
            <img
              src={heroImage}
              alt="analytics dashboard"
            />
          </div>
        )}
      </div>
    </section>
  </>
)
